import { isImageFile } from 'owa-file';
import { ONE_DRIVE_CONUSMER_API_URL } from 'owa-fileprovider-services';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { format } from 'owa-string-utils';
import { CreateSharingLinkFromFileProviderResult } from './CreateSharingLinkFromFileProviderResult';
import { createSharingLinkFromOneDriveConsumer } from './createSharingLinkFromOneDriveConsumer';

const requestUrlFormat: string = '{0}/v1.0/drive/items/{1}/action.createLink';

export async function createSharingLinkBasedOnItemIdFromOneDriveConsumer(
    fileProviderItemId: string,
    location: string
): Promise<CreateSharingLinkFromFileProviderResult> {
    const requestUrl: string = format(
        requestUrlFormat,
        ONE_DRIVE_CONUSMER_API_URL,
        fileProviderItemId
    );
    const isEdit: boolean = !isImageFile(location);

    return await createSharingLinkFromOneDriveConsumer(
        requestUrl,
        isEdit ? AttachmentPermissionLevel.Edit : AttachmentPermissionLevel.View,
        'OneDriveConsumerCreateLink'
    );
}
